import type { CartPayment as CartPaymentType } from '@eliadmin/core/src/api/cart/cart-types';
import type { ProductDetailData } from '@eliadmin/core/src/api/products/types/product-types';
import { RadioGroup } from '@eliadmin/core/src/components/ui/radio-group';
import {
  ResponsiveDialog,
  ResponsiveDialogContent,
  ResponsiveDialogHeader,
} from '@eliadmin/core/src/components/ui/responsive-dialog';
import { useState, useEffect } from 'react';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { useToast } from '@eliadmin/core/src/components/ui/use-toast';
import { Spinner } from '@eliadmin/core/src/components/ui/spinner';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import { formatPrice } from '@eliadmin/core/src/utils/price-utils';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { JobportalPaymentCard } from '../jobportal/jobportal-payment-card';
import { payCustomSubscription } from '@eliadmin/core/src/api/jobportal/orders-api';
import { getProductPriceDisplay } from '@eliadmin/core/src/utils/product-price-utils';

const VideoPresentationPaymentDialog = ({
  isOpen,
  setIsOpen,
  videoPresentationProduct,
  payments,
  type,
}: {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  videoPresentationProduct: ProductDetailData | undefined;
  payments: CartPaymentType[] | undefined;
  type: 'company' | 'student' | 'agency' | 'all_perms';
}) => {
  const { t } = useTranslations();
  const locale = useLocaleStore(s => s.currentLocale);
  const { me: meLocal } = useCustomerStore();
  const currency = useGlobalStore(s => s.generalLayout.currency);
  const [selectedPayment, setSelectedPayment] = useState(payments?.[0]?.id?.toString?.() || '');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { toast } = useToast();

  const idByType = type === 'company' ? 0 : type === 'student' ? 1 : 2;
  const selectedVariant = videoPresentationProduct?.variants?.[idByType];
  const selectedVariantPrice = selectedVariant ? getProductPriceDisplay(selectedVariant) : null;
  const canPurchase = !!selectedVariantPrice && !selectedVariantPrice.priceOnRequest;

  // Handle payments
  useEffect(() => {
    if (payments && payments.length) {
      setSelectedPayment(String(payments[0].id));
    }
  }, [payments]);

  const handleBuySubscription = () => {
    if (!videoPresentationProduct?.slug) return;
    if (!selectedVariant?.id || !canPurchase) return;
    setIsSubmitting(true);
    // payCustomSubscription({
    //   authToken: meLocal?.authToken || '',
    //   body: {
    //     payment_type: { id: parseInt(selectedPayment) ?? 2 },
    //     variants: [{ id: videoPresentationProduct?.variants?.[idByType]?.id }],
    //     subscription_type: { id: 1 },
    //     return_url: process.env.NEXT_PUBLIC_APP_URL + ROUTES.ORDER_CONFIRM(),
    //   },
    // })
    //   .then(response => {
    //     setIsSubmitting(false);
    //     if (!response?.redirect?.redirect.includes(process.env.NEXT_PUBLIC_APP_URL)) {
    //       window.location.href = response?.redirect?.redirect;
    //     } else {
    //       setIsOpen(false);
    //       window.location.reload();
    //     }
    //   })
    //   .catch(e => {
    //     setIsSubmitting(false);
    //     toast({ title: t('text1472'), description: e.message, variant: 'destructive' });
    //   });
  };

  return (
    <ResponsiveDialog open={isOpen} onOpenChange={setIsOpen}>
      <ResponsiveDialogContent className="z-[9999] flex flex-col gap-4 px-4">
        {isSubmitting ? (
          <Spinner />
        ) : (
          <>
            <ResponsiveDialogHeader>{t('Zakúpenie videoživotopisu')}</ResponsiveDialogHeader>
            <p className="text-sm font-semibold md:text-base">
              1 x {videoPresentationProduct?.name} -{' '}
              <span className="font-bold">
                {selectedVariantPrice?.priceOnRequest
                  ? t('text2278')
                  : `${formatPrice(selectedVariantPrice?.current ?? 0, currency)} ${t('text443')}`}
              </span>
            </p>
            <RadioGroup value={selectedPayment} onValueChange={setSelectedPayment}>
              {payments?.map(payment => (
                <JobportalPaymentCard key={payment.id} payment={payment} />
              ))}
            </RadioGroup>
            <div className="flex w-full justify-between">
              <Button variant="default-alt" onClick={() => setIsOpen(false)}>
                {t('text377')}
              </Button>
              <Button onClick={handleBuySubscription} disabled={!canPurchase}>
                {t('Zakúpiť')}
              </Button>
            </div>
          </>
        )}
      </ResponsiveDialogContent>
    </ResponsiveDialog>
  );
};

export default VideoPresentationPaymentDialog;
